import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import LoaderIcon from 'images/icons/loader.inline.svg'
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary.component';
import { Helmet } from 'react-helmet';


const API = React.lazy(() => import('./StoplightAPI.component'))

function APISpec({ apiFileName, pageVersion = null}){
  const [apiSpec, setApiSpec] = useState(null);
  const [error, setError] = useState(false);

  // apiFileName coming in as data frontmatter field prefixed with 'api-', remove that occurrence to get true file name
  const APIfile = apiFileName.slice(apiFileName.indexOf('-') + 1);

  useEffect(() => {
    let mounted = true;

    const loadAPI = async () => {
      if(pageVersion !== null && pageVersion?.length !== 0){
        await import(`api-docs/reference/${pageVersion}/${APIfile}.json`)
        .then(({ default: spec }) => {
          if(mounted){
            setApiSpec(spec)
            setError(false)
          }
        })
        .catch(
          err => {
            setError(true)
            console.log(err) /* eslint-disable-line no-console */
          }
        )
      } else {
        await import(`api-docs/reference/${APIfile}.json`)
          .then(({ default: spec }) => {
            if(mounted){
              setApiSpec(spec)
              setError(false)
            }
          })
          .catch(
            err => {
              setError(true)
              console.log(err) /* eslint-disable-line no-console */
            }
          )
      }
    }

    loadAPI();

    return () => {
      mounted = false;
    };
  }, [APIfile, pageVersion])

  // const message = error ? 'Could not load api spec file' : 'Loading API specification...';
  const message = error ? 'Could not load api spec file' : <LoaderIcon />;

  return (
    <>
      <Helmet>
        <link href="/assets/styles/api-styles.css" type="text/css" rel="stylesheet"/>
      </Helmet>
      <div className="main-stoplight-section-wrap"> 
        <ErrorBoundary message="API stoplight">
          {apiSpec && !error ? <React.Suspense fallback={<LoaderIcon/>}>
              <API 
                  apiDescriptionDocument={apiSpec} 
                  router="hash" 
                  logo="/favicon-32x32.png" 
                  hideInternal 
                  hideExport 
                  hideSchemas 
              />
            </React.Suspense> : message}
        </ErrorBoundary>
      </div>
    </>
  );
}; 

APISpec.propTypes = {
  apiFileName: PropTypes.string.isRequired,
  pageVersion: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ])
};

export default APISpec;
